import React from 'react';
import { siteInfo } from '../data/mock';

// Barra patrocini: immagine singola (editabile dall'admin), discreta
export default function PatrociniBar() {
  const hasImage = !!siteInfo.patrocinImage;
  return (
    <section className="py-4 bg-navy-dark/80 border-y border-white/5">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="flex flex-col items-center gap-2">
          {!hasImage && (
            <span className="text-white/50 text-[10px] font-bold uppercase tracking-[0.25em]">
              {siteInfo.patrocinTitle || 'con il patrocinio di'}
            </span>
          )}
          {hasImage ? (
            <div className="w-full max-w-2xl">
              <img
                src={siteInfo.patrocinImage}
                alt="Con il patrocinio di"
                className="w-full h-auto max-h-28 object-contain opacity-90 hover:opacity-100 transition-opacity"
              />
            </div>
          ) : (
            <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
              {siteInfo.patrocini.map((p, i) => (
                <div key={i} className="flex items-center gap-2 opacity-75 hover:opacity-100 transition-opacity">
                  <span className="w-7 h-7 rounded-full bg-white/10 border border-white/20 flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-[9px] font-bold">{p.abbr}</span>
                  </span>
                  <span className="text-white/70 text-[11px] font-medium">{p.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
